export default "__VITE_ASSET__C$WAVtNM__"